package com.eladfinish.bible.contest.screens.pastQuizzes

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.ui.components.WebViewBridge

/** No AppMetrica here. */
@Composable
actual fun rememberExamAnalyticsBridge(usageStats: Boolean): WebViewBridge? = null
